import React, { useEffect, useRef, useState } from "react";
import AddPickUpOrder from "./addPickUpOrderFields";
import moment from "moment";
import {
  createOrder,
  searchLeadForOrder,
  getCountry,
  getCity,
  createAddress,
} from "Listfunction";
import NotificationSystem from "react-notification-system";

import CreateAddressModal from "components/AddressModal/createAddressModal";

const AddPickUpOrderModal = (props) => {
  const _notificationSystem = React.createRef(null);
  var token = JSON.parse(localStorage.getItem("user"));
  const obj = token.token;
  const stores = token.store_id;
  const [loading, setLoading] = useState(false);
  const [contactName, setContactName] = useState("");
  const [selectMobileNumber, setSelectMobileNumber] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [note, setNote] = useState("");
  const [isChequeCollect, setIsChequeCollect] = useState(false);
  const [isReturnItem, setIsReturnItem] = useState(false);
  const [selectAddress, setSelectAddress] = useState("");
  const [getLeadsDetails, setGetLeadsDetails] = useState([]);
  const [supplierSearch, setSupplierSearch] = useState("");
  const [supplierOption, setSupplierOption] = useState(null);
  const [leadsOptions, setLeadsOptions] = useState([]);
  const [getAddress, setGetAddress] = useState([]);
  const [showAddressModal, setShowAddressModal] = useState(false);
  const [firstAddress, setFirstAddress] = useState(""); // first active address
  const [cityInfo, setCityInfo] = useState([]); // city list
  const [countryDetail, setCountryDetail] = useState([]);
  const [validationState, setValidationState] = useState({
    addressline1Error: null,
    cityError: null,
    countryError: null,
    addressTypeError: null,
    latiAndLogitError: null,
  });
  const [newAddress, setNewAddress] = useState(null);
  const [addressline1, setAddressline1] = useState("");
  const [addressline2, setAddressline2] = useState("");
  const [postalcode, setPostalcode] = useState("");
  const [addressType, setAddressType] = useState("");
  const [customAddress, setCustomAddress] = useState("");
  const [city, setCity] = useState(0);
  const [country, setCountry] = useState(1);
  const [inputLocation, setInputLocation] = useState("");
  const [paymentoption, setPaymentoption] = useState("");
  const [leadError, setLeadError] = useState(null);
  const [addressError, setAddressError] = useState(null);
  const [paymentOptionError, setPaymentOptionError] = useState(null);
  useEffect(() => {
    if (supplierOption && supplierOption.address) {
      const activeAddresses = supplierOption.address.filter(
        (addr) => addr.is_active === 1,
      );
      setGetAddress(activeAddresses);
      if (activeAddresses.length > 0) {
        setFirstAddress(activeAddresses[0].id);
        setSelectAddress(activeAddresses[0].id);
      }
    }
    getAllCity("1");
  }, [supplierOption]);

  const parseLatLng = (location) => {
    if (!location) return { latitude: null, longitude: null };
    const [lat, lng] = location.split(",").map((v) => v.trim());
    return {
      latitude: lat || null,
      longitude: lng || null,
    };
  };

  const handleAddressSelect = (id) => {
    setSelectAddress(id);
    setFirstAddress(id);
    setNewAddress(null);
    setAddressError(null);
  };
  const handleChange = (name, value) => {
    switch (name) {
      case "addressline1":
        setAddressline1(value);
        break;
      case "addressline2":
        setAddressline2(value);
        break;
      case "postalcode":
        setPostalcode(value);
        break;
      case "addressType":
        setAddressType(value);
        break;
      case "customAddress":
        setCustomAddress(value);
        break;
      default:
        break;
    }
  };

  const onChange = (e) => {
    const { name, value } = e.target;
    if (name === "country") {
      setCountry(value);
      setCity("0");
      setCityInfo([]);
      getAllCity(value);
    }
    if (name === "city") {
      setCity(value);
    }
  };

  const getAllCity = (countryId) => {
    if (!countryId) return;
    getCity(obj, countryId).then((res) => {
      setCityInfo(res.data || []);
    });
  };

  const getAllCountry = () => {
    getCountry(obj).then((res) => {
      setCountryDetail(res.data || []);
    });
  };

  const handleInputLocationChange = (e) => {
    setInputLocation(e.target.value);
  };

  const getAllLeadsDetails = (text) => {
    if (!text) return;
    searchLeadForOrder(text, obj).then((res) => {
      const data = res.data.data || [];
      setLeadsOptions(
        data.map((x) => ({
          value: x.id,
          label: `${x.name} (${x.mobile_no})`,
          address: x.address,
        })),
      );
    });
  };
  const validateCoordinates = (location) => {
    const { latitude, longitude } = parseLatLng(location);
    if (!latitude || !longitude) return false;
    if (isNaN(latitude) || isNaN(longitude)) return false;
    return true;
  };
  const onSubmit = () => {
    if (props.isEdit) {
      updateOrder();
    } else {
      createOrders();
    }
  };

  const updateOrder = () => {
    console.log("Clicked");
  };

  const createOrders = async () => {
    if (loading) return;
    setLoading(true);

    const notification = _notificationSystem.current;

    let hasError = false;

    if (!supplierOption) {
      setLeadError(
        <div style={{ color: "red", fontSize: "12px" }}>
          Supplier is required
        </div>,
      );
      hasError = true;
    }
    if (!selectAddress) {
      setAddressError(
        <div style={{ color: "red", fontSize: "12px" }}>
          Please select an address or add a new address
        </div>,
      );
      hasError = true;
    }
    if (!paymentoption) {
      setPaymentOptionError(
        <div style={{ color: "red", fontSize: "12px" }}>
          Payment Option is required
        </div>,
      );
      hasError = true;
    }

    if (hasError) {
      setLoading(false);
      return;
    }

    const orderPayload = {
      lead_id: supplierOption && supplierOption.value,
      source: "1",
      order_date: moment().format("YYYY-MM-DD"),
      delivery_type: "1",
      address_id: selectAddress,
      channel: "admin",
      medications: [],
      paymentoption: paymentoption && paymentoption.value,
      order_status: "1",
      margin_type: "1",
      margin: 0,
      order_sub_type: "3",
      store_id: stores,
      delivery_charge: 0,
      payment_due_date: moment().format("YYYY-MM-DD"),
      secondary_name: contactName,
      secondary_number: mobileNumber,
      pickup_note: note,
      is_return_item_collected: isReturnItem,
      is_checked_collected: isChequeCollect,
      organization_discount: 0,
    };

    createOrder(obj, orderPayload)
      .then((res) => {
        if (res.data.success) {
          if (notification) {
            notification.addNotification({
              title: <span data-notify="icon" className="pe-7s-gift" />,
              message: (
                <div>
                  <b>Pick Order</b> Created Successfully.
                </div>
              ),
              level: "success",
              position: "bl",
              autoDismiss: 15,
            });
          }
          setTimeout(() => {
            setLoading(false);
            props.history.push("/admin/order_list");
          }, 3000);
        } else {
          if (notification) {
            notification.addNotification({
              title: <span data-notify="icon" className="pe-7s-gift" />,
              message: (
                <div>
                  <b>Error:</b> {res.data.message || "Failed to add order"}
                </div>
              ),
              level: "error",
              position: "bl",
              autoDismiss: 15,
            });
          }
          setLoading(false);
        }
      })
      .catch((err) => {
        if (notification) {
          notification.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift" />,
            message: (
              <div>
                <b>Error:</b> {err.message || "Failed to add order"}
              </div>
            ),
            level: "error",
            position: "bl",
            autoDismiss: 15,
          });
        }
        setLoading(false);
      });
  };

  const closeTheModal = () => {
    setShowAddressModal(false);
  };
  const onSubmitAddress = () => {
    const notification = _notificationSystem.current;
    if (!notification) return;
    const newValidationState = {
      addressline1Error: null,
      cityError: null,
      countryError: null,
      addressTypeError: null,
      latiAndLogitError: null,
    };

    if (!addressline1 || !addressline1.trim()) {
      newValidationState.addressline1Error = (
        <small className="text-danger">Address is required.</small>
      );
    }

    if (!city || city === "0") {
      newValidationState.cityError = (
        <small className="text-danger">District is required.</small>
      );
    }

    if (!country || country === "0") {
      newValidationState.countryError = (
        <small className="text-danger">Country is required.</small>
      );
    }

    if (!addressType || addressType === "") {
      newValidationState.addressTypeError = (
        <small className="text-danger">Address Type is required.</small>
      );
    }

    if (!inputLocation || !validateCoordinates(inputLocation)) {
      newValidationState.latiAndLogitError = (
        <small className="text-danger">
          Latitude and Longitude are required (format: lat,lng).
        </small>
      );
    }

    setValidationState(newValidationState);
    const hasErrors = Object.values(newValidationState).some(Boolean);
    if (hasErrors) return;
    const { latitude, longitude } = parseLatLng(inputLocation);
    const addressPayload = {
      address_line1: addressline1,
      address_line2: addressline2,
      postal_code: postalcode,
      city: city,
      country_id: country,
      latitude,
      longitude,
      address_type: addressType,
      custom_address: addressType === "Custom" ? customAddress : null,
    };
    createAddress(
      obj,
      addressPayload,
      supplierOption && supplierOption.value,
    ).then((res) => {
      if (res.data.success) {
        const subscriber = res.data.data;

        // Update address list with all addresses from subscriber
        if (subscriber.address && Array.isArray(subscriber.address)) {
          const activeAddresses = subscriber.address.filter(
            (addr) => addr.is_active === 1,
          );
          setGetAddress(activeAddresses);

          // Auto-select the newly created address using address_id
          const newAddressId = subscriber.address_id;
          setSelectAddress(newAddressId);
          setFirstAddress(newAddressId);
        }

        // Clear form fields
        setAddressline1("");
        setAddressline2("");
        setPostalcode("");
        setAddressType("");
        setCustomAddress("");
        setCity("0");
        setCountry("1");
        setInputLocation("");

        setShowAddressModal(false);
        setValidationState({
          addressline1Error: null,
          cityError: null,
          countryError: null,
          addressTypeError: null,
          latiAndLogitError: null,
        });

        notification.addNotification({
          title: <span data-notify="icon" className="pe-7s-gift" />,
          message: (
            <div>
              <b>Address</b> Created Successfully.
            </div>
          ),
          level: "success",
          position: "bl",
          autoDismiss: 15,
        });
      }
    });
  };

  return (
    <div>
      <NotificationSystem ref={_notificationSystem} />
      <AddPickUpOrder
        isEdit={false}
        setContactName={setContactName}
        contactName={contactName}
        selectMobileNumber={selectMobileNumber}
        setSelectMobileNumber={setSelectMobileNumber}
        setMobileNumber={setMobileNumber}
        mobileNumber={mobileNumber}
        note={note}
        setNote={setNote}
        isChequeCollect={isChequeCollect}
        setIsChequeCollect={setIsChequeCollect}
        setIsReturnItem={setIsReturnItem}
        isReturnItem={isReturnItem}
        setSelectAddress={setSelectAddress}
        selectAddress={selectAddress}
        onSubmit={onSubmit}
        loading={loading}
        getLeadsDetails={getLeadsDetails}
        supplierOption={supplierOption}
        setSupplierSearch={setSupplierSearch}
        setSupplierOption={setSupplierOption}
        getAllLeadsDetails={getAllLeadsDetails}
        leadsOptions={leadsOptions}
        getAddress={getAddress}
        handleAddressSelect={handleAddressSelect}
        firstAddress={firstAddress}
        setFirstAddress={setFirstAddress}
        city_info={cityInfo}
        countryDetail={countryDetail}
        onAddAddressClick={() => {
          setShowAddressModal(true);
          getAllCountry();
        }}
        newAddress={newAddress}
        setLeadError={setLeadError}
        leadError={leadError}
        setAddressError={setAddressError}
        addressError={addressError}
        paymentoption={paymentoption}
        setPaymentoption={setPaymentoption}
        setPaymentOptionError={setPaymentOptionError}
        paymentOptionError={paymentOptionError}
      />
      <CreateAddressModal
        show={showAddressModal}
        onHide={() => {
          setShowAddressModal(false);
          setValidationState({
            addressline1Error: null,
            cityError: null,
            countryError: null,
            addressTypeError: null,
            latiAndLogitError: null,
            addressline1Error: null,
          });
        }}
        onSubmitAddress={onSubmitAddress}
        city_info={cityInfo}
        country_detail={countryDetail}
        addressline1={addressline1}
        addressline2={addressline2}
        postalcode={postalcode}
        addressType={addressType}
        customAddress={customAddress}
        city={city}
        country={country}
        input={inputLocation}
        handleChange={handleChange}
        onChange={onChange}
        handleInputLocationChange={handleInputLocationChange}
        validationState={validationState}
        closeTheModal={closeTheModal}
      />
    </div>
  );
};
export default AddPickUpOrderModal;
